export interface TaskLogState {
  filter: string;
  sortColumn: string;
  sortDirection: string;
  page: number;
  pageSize: number;
  fromDate: string | null;
  toDate: string | null;
}

/**
 * Remembers the Task log filters (date range, search, sort, page) while the
 * user moves between the log and a task's detail pages.
 *
 * It is kept in memory only (not localStorage/sessionStorage), so a page
 * refresh, closing the tab, or signing out always starts from the defaults.
 */
export class TaskLogMemory {
  private static state: TaskLogState | null = null;

  static save(state: TaskLogState): void {
    TaskLogMemory.state = { ...state };
  }

  static load(): TaskLogState | null {
    return TaskLogMemory.state ? { ...TaskLogMemory.state } : null;
  }

  static clear(): void {
    TaskLogMemory.state = null;
  }
}
